import { FlaskConical } from 'lucide-react'
import type { TenantMode } from '@lib/enums/tenant-mode.enum'
import { SegmentedControl, type SegmentedOption } from '@/components/ui/segmented-control'

interface ModeSwitchProps {
  mode: TenantMode
  onChange: (mode: TenantMode) => void
}

const OPTIONS: SegmentedOption<TenantMode>[] = [
  { value: 'live', label: 'Live' },
  {
    value: 'test',
    label: (
      <>
        <FlaskConical />
        Test
      </>
    ),
    ariaLabel: 'Test',
    tone: 'warning',
  },
]

/** Live / Test, side by side. Test is amber so it is never mistaken for live. */
export function ModeSwitch({ mode, onChange }: ModeSwitchProps) {
  return <SegmentedControl ariaLabel="Mode" value={mode} onChange={onChange} options={OPTIONS} fullWidth />
}

/** Across the top of every page while the dashboard shows test data. */
export function TestModeBanner() {
  return (
    <div
      role="status"
      className="mb-6 flex items-center gap-2 rounded-lg border border-warning-border bg-warning-subtle px-3 py-2 text-body text-warning"
    >
      <FlaskConical className="size-4 shrink-0" />
      <span>
        <strong className="font-semibold">Test mode.</strong> Keys, webhooks, embedding, and envelopes are separate from
        live, and nothing here is legally binding. The organization profile and team are shared with live.
      </span>
    </div>
  )
}
